import * as React from 'react';
import { useState, useEffect, useCallback }  from 'react';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Alert from '@mui/material/Alert';
import { app } from '../../config/app.js';
import {  getPermission } from '../../controller/user.js';
import  { useRef } from "react";
import { downloadPdf } from '../../controller/utils.js';
import {  getData,getHeaders, deleteDocElement } from '../../controller/firestore.js';
import {  getDataByKey } from '../../controller/firestore.js';
import { updateDocToDb } from '../../controller/firestore.js';

import {getGuideTable} from '../../config/collections/guide.js'; // Adjust the path as necessary

import Button from '@mui/material/Button';
import dayjs from 'dayjs';
import { DateTimeField } from '@mui/x-date-pickers/DateTimeField';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { DateField } from '@mui/x-date-pickers';
import {  Navigate , Link } from 'react-router-dom';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import { useLocation } from 'react-router-dom';

import Stack from '@mui/material/Stack';
import ViewRecord from '../ViewRecord.js';
import { DataGrid } from '@mui/x-data-grid';
const getRowHeight = (params) => {
  // Controlla se il contenuto della cella è lungo e richiede più righe
  const isMultiLine = false;/* params.row.col1.length > 20 || params.row.col2.length > 20;*/
  
  return isMultiLine ? 50 : 25; // Imposta l'altezza a 50px per righe multiple, 25px per righe singole
};
export default function SchedaCandidato(props) {
  const user=props.user;
  
  const reportRef = useRef();
  const collectionName="guide";
  const location=useLocation();
  const httpdata = location.state && location.state.data;
  const candidatoData = (httpdata && httpdata.candidato ? httpdata.candidato : null);
  const [filters,setFilters] =useState({"candidato":{type:'equalTo', value:candidatoData.id}});
  
  const [dataViewToRender,setDataViewToRender] = useState(false);
  
  const [errorMessage,setErrorMessage] =useState("");
  const [headers, setHeaders] = useState(null);
  const [rows, setRows] = useState(null);
  
    const activePermission=getPermission("collection",collectionName,null,user);
    const collectionConfig=app.collections_config[collectionName];
    const currentPath = location.pathname;

    const [lastQuery, setlastQuery] = useState({});
    
  const [data,setData] =useState(null);
  let isLoading=false;
  useEffect(() => {
    
    const fetchData = async () => {
      
      const params={
        "orderBy":"date",
        "permission":activePermission,
        "filters":filters,
        "user":user,
        "viewAction":null
      };
      //console.log("APP object",app);
      //console.log("collectionName",collectionName);
      let viewConfig=app.collections_config[collectionName].views["table"];
      setlastQuery(params);
      
      const table=await getData(collectionName,viewConfig,params);
      const convertedTable=getGuideTable(table,candidatoData.categoria);
      setHeaders(convertedTable.headers);
      setRows(convertedTable.rows);
      setData( table);
      isLoading=false;
      
      setDataViewToRender(true);
   };
    if (isLoading) return;
    isLoading=true;
    
    setDataViewToRender(true);
    fetchData();
  }, [collectionName,filters]);
  const initialState= {
    columns: {
        columnVisibilityModel: {
            id:false
        }
    }
};


  return (
   <div><div ref={reportRef}><Typography sx={{ mb: 2 }} variant="h6">Scheda di <b>{candidatoData.nome} {candidatoData.cognome}</b> (Cat. {app.category[candidatoData.categoria]})</Typography>

          {dataViewToRender  && data && data.body  ? (
          
            data.body.length>0 ? (
            <DataGrid
                rows={ rows}
                columns={headers}
                className="schedaCandidatoGrid"
                initialState={initialState}
                getRowClassName={(params) => (params.row.isCategory === true ? 'isSchedaCategory' : 'isNotSchedaCategory')+' field-'+params.id+(params.row.type ? ' type-'+params.row.type:'')}
                disableColumnReorder // Disabilita il drag-and-drop delle colonne
                disableColumnSelector // Disabilita il selettore di colonne
                disableSelectionOnClick
                disableColumnMenu 
                getRowHeight={getRowHeight} 
                sx={{
                  "& .MuiDataGrid-columnHeader": {                    
                    backgroundColor: "lightgray",
                    borderLeft: "1px solid #f0f0f0",
                    padding: "0px", // Riduci o azzera il padding
                  }, "& .MuiDataGrid-columnHeader .MuiDataGrid-columnHeaderTitle": {
                    lineHeight: 1.2,
                    padding: "0px",
                    textAlign: "center",
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                  },
                }}
                hideSortIcons
                hideFooter 
                isRowSelectable={() => false} // Disable row selection
                isCellEditable={() => false} // Disable cell editing
                
            /> ) : <Typography sx={{pt:2}} gutterBottom>Nessuna guida trovata</Typography> )
            : <Typography sx={{pt:2}} gutterBottom>Caricamento in corso..</Typography>}
       </div>
       {window.innerWidth > window.innerHeight && window.innerWidth >= 768 && (
  <Button
    variant="contained"
    sx={{ mt: 2 }}
    onClick={function () {
      downloadPdf(
        reportRef,
        "Scheda di " + candidatoData.nome + " " + candidatoData.cognome + ".pdf",
        {
          orientation: "landscape",
          unit: "mm",
          format: "a4",
        }
      );
    }}
  >
    Salva PDF
  </Button>
)}
   </div>
      
  );
}